import styled, { css } from 'styled-components';

import { Col as BaseColumn } from '@/components/Col';
import { Flex } from '@/components/Flex';
import { LegacyButton } from '@/components/LegacyButton';
import { Row } from '@/components/Row';

export const Wrapper = styled(Row)`
  ${({ theme }) => css`
    ${theme.media.md.down} {
      display: none;
    }
  `}
`;

export const MobileWrapper = styled(Flex)`
  ${({ theme }) => css`
    ${theme.media.md.up} {
      display: none;
    }
  `}
`;

export const collectionCTA = styled(LegacyButton)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(2)};
  `}
`;
export const Subheader = styled.div`
  text-align: center;
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.h5};
    font-family: ${theme.fontFamilies.italianPlate};
    padding-bottom: ${theme.spacing(1)};
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const Col = styled(BaseColumn)`
  grid-column: span 6;
  display: flex;
  width: 100%;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      grid-column: span 4;
    }
  `}
`;

export const ParameterCol = styled(BaseColumn)`
  grid-column: span 6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      grid-column: span 4;
    }
  `}
`;
